import { faTimes, faTimesCircle } from "@fortawesome/pro-regular-svg-icons";
import { faReports } from "extensions/fa5-icons/faReports";
import { createRef, Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

import { pazienHistory } from "common/components/pazienHistory";
import { FETCH_REPORT_NOTIFICATIONS, MARK_REPORT_READ, MARK_ALL_REPORTS_READ } from "common/actions/reports_notifications";

import { PanelIcon, HeaderActions, NotificationPopup, PanelHeader, Title, FullHeightList, NoDataAvailable, RowItem } from "./notificationPopup";
import { PopupActions } from "./popup_actions";

const mapStateToProps = (state) => ({
    loading: state.report_notifications.loading,
    loaded: state.report_notifications.loaded,
    NotificationsData: state.report_notifications.data || []
});

const mapDispatchToProps = {
    FETCH_REPORT_NOTIFICATIONS,
    MARK_REPORT_READ,
    MARK_ALL_REPORTS_READ
};

class reportsPopup extends Component {
    static viewAll(close) {
        pazienHistory.navigateWithParams("/reports", { trigger: true });
        setTimeout(close(), 0);
    }
    
    constructor(props) {
        super(props);
        this.popupRef = createRef();
    }
    
    componentDidMount() {
        this.props.FETCH_REPORT_NOTIFICATIONS();
    }
    
    clearAll = () => {
        this.props.MARK_ALL_REPORTS_READ().catch((error) => {});
    };
    
    renderItems = () => {
        const onlyUnread = this.props.NotificationsData.filter((n) => !n.last_viewed);
        if (onlyUnread.length === 0) {
            return <NoDataAvailable>You have no new reports</NoDataAvailable>;
        }
        
        return onlyUnread.map((i) => (
            <RowItem key={`report_item_${i._id}`}>
                <div className="info">
                    <div className="title">{i.display_name}</div>
                    <div className="date">{moment.utc(i.modified).local().format("MMM DD, YYYY")}</div>
                </div>
                <div className="icon close" onClick={() => this.props.MARK_REPORT_READ(i._id).catch((error) => {})}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </RowItem>
        ));
    };
    
    render() {
        const closeMe = () => this.popupRef.current.close();
        const onlyUnread = this.props.NotificationsData.filter((n) => !n.last_viewed);
    
        return (
            <NotificationPopup
                icon={faReports}
                ref={this.popupRef}
                iconStyle="reports"
                title="Reports"
                onVisibilityChange={this.props.onVisibilityChange}
                hasIndicator={onlyUnread.length > 0}
            >
                <div>
                    <PanelHeader>
                        <Title>Reports</Title>
                        <HeaderActions>
                            <PanelIcon onClick={closeMe}><FontAwesomeIcon icon={faTimes} /></PanelIcon>
                        </HeaderActions>
                    </PanelHeader>
                    <PopupActions viewAll={() => reportsPopup.viewAll(closeMe)} clearAll={this.clearAll} hasItems={(onlyUnread.length > 0)}/>
                    <FullHeightList>{this.renderItems()}</FullHeightList>
                </div>
            </NotificationPopup>
        );
    }
}

export const ReportsPopup = connect(mapStateToProps, mapDispatchToProps)(reportsPopup);
